<div nz-row>
    <div nz-col>
        <div class="page-header">
            <button nz-button nzType="primary" (click)="this.createActivityRelation()">
                {{ 'relation-relation.detail.add-activity' | translate }}
                <i class="fa-solid fa-plus"></i>
            </button>
        </div>
        <app-relation-relation-overview-table
            [data]="data"
            (delete)="delete.emit($event)"
            (resetOverview)="this.resetOverview.emit($event)" 
            ></app-relation-relation-overview-table>
    </div>
</div>
